import hostname from './config.host';
import { fetchWrapper } from './fetch-wrapper';
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getAllWebsiteTarget(oauthTokenHeader:string,website_shared_uid:any){
    return fetchWrapper.get(`${apiUrl}/asset_management/overview/website_targets/${website_shared_uid}/`,oauthTokenHeader);
}

function getWebsiteMicroTargets(oauthTokenHeader:string,website_shared_uid:any){
    return fetchWrapper.get(`${apiUrl}/asset_management/overview/website_micro_targets/${website_shared_uid}/`,oauthTokenHeader);
}

function postWebsiteTarget(oauthTokenHeader:string,data:any, website_shared_uid:any){
    return fetchWrapper.post(`${apiUrl}/asset_management/overview/website_targets/${website_shared_uid}/`,data, oauthTokenHeader);
}

function postWebsiteMicroTarget(oauthTokenHeader:string,data:any, website_shared_uid:any){
    return fetchWrapper.post(`${apiUrl}/asset_management/overview/website_micro_targets/${website_shared_uid}/`,data, oauthTokenHeader);
}

function updateWebsiteMicroTarget(oauthTokenHeader:string,data:any, website_target_shared_uid:any){
    return fetchWrapper.put(`${apiUrl}/asset_management/overview/website_micro_targets/${website_target_shared_uid}/`,data, oauthTokenHeader);
}

function getSingleWebsiteTarget(oauthTokenHeader: any, website_shared_uid: any, website_target_shared_uid:any) {
    return fetchWrapper.get(`${apiUrl}/asset_management/overview/website_targets/${website_shared_uid}/?website_target_shared_uid=${website_target_shared_uid}`, oauthTokenHeader);
}

function updateWebsiteTarget(oauthTokenHeader: any, data: any, website_target_shared_uid: any) {
    return fetchWrapper.put(`${apiUrl}/asset_management/overview/website_targets/${website_target_shared_uid}/`, data, oauthTokenHeader);
}

function getGeo(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/geos/`, oauthTokenHeader)
}

function getProductType(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/products/`, oauthTokenHeader)
}

export const websitesTargetService = { getAllWebsiteTarget, getWebsiteMicroTargets, postWebsiteTarget, updateWebsiteTarget, getGeo, getProductType, getSingleWebsiteTarget, postWebsiteMicroTarget, updateWebsiteMicroTarget };
